import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faLocationDot, faPhone, faEnvelope, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import {faDiscord, faGithub, faLinkedinIn, faWhatsapp} from "@fortawesome/free-brands-svg-icons";
import styles from '../styles/contact.module.css';

const Contact = () => {

  const [isSubmitted, setIsSubmitted] = useState(false); // Track form submission status
  const [isSubmitting, setIsSubmitting] = useState(false); // Track form submitting state

  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent default form submission behavior
    setIsSubmitting(true);  // Set submitting state

    // Get form data and encode it as URL-encoded form data
    const formData = new URLSearchParams(new FormData(event.target));

    // Simulate form submission via fetch (or Axios)
    try {
      const response = await fetch('/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded', // Set the correct content type
        },
        body: formData,
      });

      if (response.ok) {
        // On successful submission
        setIsSubmitted(true);
      } else {
        console.error('Form submission failed');
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setIsSubmitting(false); // Reset submitting state after the operation
    }
  };

  return (
    <div className={styles.contactContainer}>
      <h1 className={styles.pageHead}>GET IN TOUCH!</h1>

      <div className={styles.formBox}>
        <form className={styles.contactForm} method="POST" onSubmit={handleSubmit}>
          <p>{">"} Want to hire me or just reach out for a possible collaboration?<br /><br /> Fill out this form and I'll get back to you as soon as possible!</p>
          <input name="name" id='name' placeholder='Name' type='text' required />
          <input name="email" id='email' placeholder='Email' type='email' required />
          <textarea name="message" id='message' placeholder='Message (optional)' />
          <div className={styles.checkBox}>
            <input type="checkbox" id="CV" name="CV" value="True" />
            <label for="CV">Would you like to request a CV?</label>
          </div>
          <button
            id='submit'
            type='submit'
            className={styles.submitBtn}
            disabled={isSubmitted || isSubmitting} // Disable the button after submission
          >
            <div className={styles.sendAltBtn}>
            <span className={styles.sendIcon}>
              {isSubmitted ? <FontAwesomeIcon icon={faThumbsUp} /> : isSubmitting ? 'SENDING...' : <FontAwesomeIcon icon={faPaperPlane} />}
            </span>
            <span className={styles.sendText}>
              {isSubmitted ? 'SUBMITTED' : 'SEND'}
            </span>
            </div>
          </button>
        </form>
        <hr className={styles.formDivider} />
        <div className={styles.contactInfo}>
          <div className={styles.contactDetails}>
            <ul className={styles.contactList}>
              <li className={styles.listItem}><FontAwesomeIcon className={styles.contactIcon} icon={faLocationDot} size='2x' /><span className={styles.contactText}>London, United Kingdom</span></li>
              <li className={styles.listItem}><FontAwesomeIcon className={styles.contactIcon} icon={faPhone} size='2x' /><span className={styles.contactText}><a href="tel:+447399937577">(+44) 07399 937 577</a></span></li>
              <li className={styles.listItem}><FontAwesomeIcon className={styles.contactIcon} icon={faEnvelope} size='2x' /><span className={styles.contactText}><a href="mailto:jared.santoro@santoro-london.com">jared.santoro@santoro-london.com</a></span></li>
            </ul>
          </div>
          <hr className={styles.contactDivider} />
          <div className={styles.socialsContainer}>
            <a href="https://github.com/jazzajing" className={styles.socialIcon}><FontAwesomeIcon icon={faGithub} size='2x' /></a>
            <a href="https://discordapp.com/users/696108390589661225" className={styles.socialIcon}><FontAwesomeIcon icon={faDiscord} size='2x' /></a>
            <a href="https://www.linkedin.com/in/jared-santoro-9b57651a2/" className={styles.socialIcon}><FontAwesomeIcon icon={faLinkedinIn} size='2x' /></a>
            <a href="https://wa.me/4407399937577" className={styles.socialIcon}><FontAwesomeIcon icon={faWhatsapp} size='2x' /></a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
